import { type PortableTextTypeComponent } from '@portabletext/react';

export const DisabledOutputHtml: PortableTextTypeComponent = () => null;
